<template>
	<div class="password">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span>修改密码</span>
			<div></div>
		</div>
		<div class="main">
			<van-cell-group>
				<van-field v-model="newPassword" type="password" clearable placeholder="填写新密码" label="新密码" />
				<van-field v-model="passwords" type="password" clearable placeholder="再次填写确认" label="确认密码" />
			</van-cell-group>
			<div class="tips">密码必须是6~18位的数字</div>
			<div class="btn">
				<van-button slot="button" size="small" type="primary" @click="submit">确认修改</van-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				newPassword: '',
				passwords: ''
			}
		},
		methods: {
			//提交
			submit() {
				if (this.newPassword == '' || this.passwords == '') {
					this.$toast('密码不能为空');
					return false;
				} else if (this.newPassword.length < 6 || this.newPassword.length > 12) {
					this.$toast('密码只能为6-12位');
					return false;
				} else if (this.passwords.length < 6 || this.passwords.length > 12) {
					this.$toast('密码只能为6-12位');
					return false;
				} else if (this.newPassword != this.passwords) {
					this.$toast('两次密码不一致');
					return false;
				}
				this.$axios.post(baseUrl + '/mobile/User/userUpdatePassword', {
					password: this.passwords,
					token: localStorage.getItem('Authorization')
				}).then((res) => {
					if (res.data.code == 7) {
						this.$toast(res.data.msg);
						this.back();
					}
				}).catch((err) => {
					console.log(err);
				});
			},
		}
	}
</script>

<style scoped>
	.password {
		height: 100%;
		background: #fff;
		padding-top: 2rem;
	}

	.password .main {
		width: 80%;
		margin: auto;
		margin-top: 2rem;
	}

	.password .main .tips {
		font-size: 0.7rem;
		color: #b0b0b0;
		text-align: left;
		padding: 1rem 0 0 1rem;
	}

	.password .main .btn {
		margin-top: 2rem;
	}

	.password .main .van-cell-group button {
		border-radius: 1rem;
		background: #c9c9c9;
		border: 0;
	}

	.password .main .van-cell-group {
		text-align: left;
	}

	div .password .van-button {
		background: #F1452F !important;
	}

	.password .main .btn button {
		width: 75%;
		background: #F1452F;
		border: 0;
		color: #fff;
		font-size: 0.9rem;
		height: 2rem;
		border-radius: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/min/setting/Change_pswd.vue